var MODELS = ['funnels', 'people', 'settings'];

class Requester {
    constructor(app) {
        var _ = this;

        _.app = app;
    }

    request(data, done) {
        var _ = this;

        data._request = Math.random();
        data._action = data.action;
        data._controller = data.controller;

        delete data.controller;

        data.action = 'drip_funnels_api';

        window.jQuery.ajax({
            method: 'POST',
            dataType: 'json',
            url: window.ajaxurl,
            data: data,
            success(response) {
                var model;

                for (var i = MODELS.length - 1; i >= 0; i--) {
                    model = MODELS[i];

                    if (!(response[MODELS[i]] instanceof Array)) {
                        continue;
                    }

                    if (!_.app[model].length) {
                        _.app[model] = response[model];
                    } else {
                        response[model].forEach(function(record) {
                            var found = _.app[model].find(function(item) {
                                return item.id + '' === record.id + '';
                            });

                            if (found) {
                                for (var key in record) {
                                    found[key] = record[key];
                                }
                            } else {
                                _.app[model].push(record);
                            }
                        });
                    }
                }

                if (typeof done === 'function') {
                    done(response ? response.error : 'No resources found.', response ? response : undefined);
                }
            },
            error(err, status) {
                if (typeof done === 'function') {
                    done('No resources found.');
                }
            }
        });
    }
}

export default Requester;
